<script setup>
import OverlayComponent from "@/components/OverlayComponent.vue";
import {MapPinIcon} from "@heroicons/vue/16/solid";

const props = defineProps({
  creator: {
    default: null,
    type: Object
  },
})
// Const isFollowing = ref(false)
</script>

<template>
  <div class="container md:max-w-7xl mx-auto text-left py-28 px-16 relative z-20">
    <div class="flex flex-1 space-x-3">
      <img
        class="h-32 w-32 rounded-full"
        :src="props.creator?.profile?.avatar"
        alt=""
      >
      <div>
        <h1 class="h1 text-white text-5xl font-bold drop-shadow">
          {{ props.creator?.full_name }}
        </h1>
        <h2 class="h3 text-gray-100 font-medium text-xl my-2 drop-shadow">
          {{ props.creator?.name }}
        </h2>
        <p class="mb-0 text-sm h6 text-red-600 drop-shadow">
          <MapPinIcon class="h-6 w-6 inline" />
          <span class="font-light">{{ props.creator?.profile?.location }}</span>
        </p>
        <p class="text-gray-400 font-semibold text-base leading-6 mt-4 drop-shadow">
          {{ props.creator?.profile?.bio }}
        </p>
      </div>
    </div>
  </div>
  <OverlayComponent />
</template>

<style scoped>

</style>
